import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const MongoAPIKeyDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.display_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.display_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.mongo_atlas_api_key_data?.access_list !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>API Access List</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData.mongo_atlas_api_key_data.access_list ? "yes" : "No"
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.mongo_atlas_api_key_data?.projects?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Projects</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            {entityData?.mongo_atlas_api_key_data?.projects.map((project) => (
              <TextIntegrationStyle
                title={""}
                value={project}
              ></TextIntegrationStyle>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MongoAPIKeyDetailsView;
